import { BadgeOption } from 'src/types';
import { ICON_MAP } from 'src/utils/constants';
import { SUBSCRIPTION_ITEM_QUANTITY_EVENT_TYPE } from 'src/features/subscriptionItemQuantityEvents/utils/types';
import { subItemQuantityEventMessages } from 'src/features/subscriptionItemQuantityEvents/utils/messages';

export const QUANTITY_EVENT_TYPE_BADGE_OPTIONS: Record<SUBSCRIPTION_ITEM_QUANTITY_EVENT_TYPE, BadgeOption> = {
    [SUBSCRIPTION_ITEM_QUANTITY_EVENT_TYPE.SET]: {
        label: subItemQuantityEventMessages.set,
        theme: 'blue',
        icon: ICON_MAP.SET,
    },
    [SUBSCRIPTION_ITEM_QUANTITY_EVENT_TYPE.INCREMENT]: {
        label: subItemQuantityEventMessages.increment,
        theme: 'green',
        icon: ICON_MAP.INCREMENT,
    },
    [SUBSCRIPTION_ITEM_QUANTITY_EVENT_TYPE.DECREMENT]: {
        label: subItemQuantityEventMessages.decrement,
        theme: 'red',
        icon: ICON_MAP.DECREMENT,
    },
};

export const QUANTITY_EVENT_TYPE_MAP = {
    [SUBSCRIPTION_ITEM_QUANTITY_EVENT_TYPE.SET]: subItemQuantityEventMessages.set,
    [SUBSCRIPTION_ITEM_QUANTITY_EVENT_TYPE.INCREMENT]: subItemQuantityEventMessages.increment,
    [SUBSCRIPTION_ITEM_QUANTITY_EVENT_TYPE.DECREMENT]: subItemQuantityEventMessages.decrement,
};
